export function isIE() {
	return navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./);
}

export function arrayFrom(arrayLikeObj) {
	return isIE() ? Array.prototype.slice.call(arrayLikeObj) : Array.from(arrayLikeObj);
}

function getSystemColorScheme() {
	if (!window.matchMedia) return false;
	return window.matchMedia('(prefers-color-scheme: dark)');
}

function setFavicon(isDark) {
	const linkFavicon = document.querySelector('link[rel="shortcut icon"]');
	if (linkFavicon) {
		linkFavicon.href = isDark ? '/favicon-dark.ico' : '/favicon.ico';
	}
}

export function listenColorSchemeChanges() {
	const colorScheme = getSystemColorScheme();
	if (colorScheme) colorScheme.addEventListener('change', ({ matches }) => {
		setFavicon(matches);
	});
}

export function updateFaviconByScheme() {
	const colorScheme = getSystemColorScheme();
	if (!colorScheme) return;
	setFavicon(colorScheme.matches);
}

export function debounce(callback, wait) {
	let timeoutId = null;
	return (...args) => {
		window.clearTimeout(timeoutId);
		timeoutId = window.setTimeout(() => {
			callback.apply(null, args);
		}, wait);
	};
}

var preventCallback = false;

export function throttle(callback, wait) {
	// If currently throttled, ignore the request
	if (preventCallback) return;

	return (...args) => {
		// Ignore any future requests for the next x seconds
		preventCallback = true;

		setTimeout(function() {
			preventCallback = false;
			callback.apply(null, args);
		}, wait);
	};
}

export function getNested(obj, ...args) {
	return args.reduce((obj, level) => obj && obj[level], obj);
}

export function checkFetchForError(response) {
	if (response.ok) return response;

	const status = response.status;
	const errCallback = response => {
		let errorMsg;

		if (Array.isArray(response)) {
			errorMsg = JSON.stringify(response);
		} else {
			errorMsg = getNested(response, 'errors', [0], 'title') || `Network response returned a "${status}" status code`;
		}

		throw new Error(errorMsg);
	};

	return response.headers.get('content-type').includes('text/html')
		? response.text().then(errCallback)
		: response.json().then(errCallback);
}

export function parseFetchResponse(response) {
	const contentType = response.headers.get('content-type');

	if (contentType && contentType.includes('text/html')) {
		return response.text();
	} else {
		return response.json();
	}
}

export function pull(arr, values) {
	var parsedValues = (typeof values === 'number') ? values.toString() : values;

	return arr.filter(function(item) {
		return parsedValues.indexOf(item) < 0;
	});
}

export function isVisible(element) {
	if (element.closest('.owl-item') && !element.closest('.owl-item').classList.contains('active')) return false;

	return !!element.offsetHeight && !!element.offsetWidth;
}

export function getVisibleElement(querySelector, reverse) {
	var elementArray = Array.from(document.querySelectorAll(querySelector));

	if (reverse) elementArray = elementArray.reverse();

	return elementArray.find(isVisible);
}

export function fadeOut(element) {
	var fadeEffect = setInterval(function() {
		if (!element.style.opacity) {
			element.style.opacity = 1;
		}

		if (element.style.opacity > 0) {
			element.style.opacity -= 0.1;
		} else {
			clearInterval(fadeEffect);
			element.style.display = 'none';
		}
	}, 50);
}



export function makeSlider(element, manuallyToggleBtns) {
	const nextBtn = element.querySelector('.btn--next');
	const previousBtn = element.querySelector('.btn--previous');
	const isAtEnd = () => (element.scrollLeft + element.offsetWidth) === element.scrollWidth;
	const isAtStart = () => element.scrollLeft === 0;

	const toggleBtnVisibility = () => {
		if (isAtEnd()) nextBtn.style.display = 'none';
		else nextBtn.style.display = 'flex';

		if (isAtStart()) previousBtn.style.display = 'none';
		else previousBtn.style.display = 'flex';
	};

	const toggleBtnDisabledClass = () => {
		if (isAtEnd()) nextBtn.classList.add('disabled');
		else nextBtn.classList.remove('disabled');

		if (isAtStart()) previousBtn.classList.add('disabled');
		else previousBtn.classList.remove('disabled');
	};

	const toggleBtn = manuallyToggleBtns ? toggleBtnDisabledClass : toggleBtnVisibility;

	toggleBtn();

	var scrollSlider = debounce(function(e) {
		var scrollX, scrollLeft;
		var closestContainer = element.closest('.content-container--large');
		let sliderItems = element.querySelectorAll('.slider-item');

		if (!closestContainer) {
			closestContainer = element.closest('.wrapper-container');
		}

		if (!closestContainer) throw new Error('No container found for slider');

		if (sliderItems && sliderItems.length > 0) {
			scrollX = isAtStart() || isAtEnd() ? sliderItems[0].clientWidth : sliderItems[1].clientWidth;
		} else if (window.innerWidth < 560) {
			scrollX = window.innerWidth;
		} else if (window.innerWidth >= 1376) {
			scrollX = closestContainer.clientWidth * 2;
		} else {
			scrollX = closestContainer.clientWidth;
		}

		scrollLeft = (e.target.classList.contains('btn--next')) ? scrollX + element.scrollLeft : -(scrollX - element.scrollLeft);

		element.scroll({
			left: scrollLeft,
			behavior: 'smooth'
		});
	}, 150);

	element.addEventListener('scroll', toggleBtn);
	window.addEventListener('resize', toggleBtn);
	element.querySelectorAll('.btn').forEach(function(buttonElement) {
		buttonElement.addEventListener('click', scrollSlider);
	});

	// Hide scrollbar, but maintain scrollability on FF
	if (navigator.userAgent.match(/firefox/i)) {
		element.classList.add('slider--firefox');
	}
}
